import TokenRetriever from '../components/Authentication/TokenRetriever';
import currentStage from '../stages.const';
import { isLocalDevelopment, LOCAL_CONFIG } from '../config/local.config';
import { baseUrl } from '../api/ApiEndpoints';

interface UserContext {
  sub: string;
  AMZN_LOC_DESCR: string;
  DISPLAY_NAME: string;
  BUILDING_CODE: string;
  MANAGER_LOGIN: string;
  COUNTRY: string;
  COST_CENTER: string;
  JOB_TITLE: string;
  screenResolution: string;
  deviceType: 'mobile' | 'tablet' | 'desktop';
}

interface AnalyticsEvent {
  eventType: string;
  userContext: UserContext;
  timestamp: string;
}

class Analytics {
  private sessionTracked = false;

  private getUserContext(): UserContext | null {
    const width = window.screen.width;
    const height = window.screen.height;
    
    let deviceType: 'mobile' | 'tablet' | 'desktop' = 'desktop';
    if (width <= 768) deviceType = 'mobile';
    else if (width <= 1024) deviceType = 'tablet';

    // Local development mode
    if (isLocalDevelopment()) {
      return {
        sub: LOCAL_CONFIG.MOCK_USER.uid,
        AMZN_LOC_DESCR: 'Local Development',
        DISPLAY_NAME: LOCAL_CONFIG.MOCK_USER.fullName,
        BUILDING_CODE: 'LOCAL',
        MANAGER_LOGIN: 'local-manager',
        COUNTRY: 'AU',
        COST_CENTER: 'DEV',
        JOB_TITLE: 'Developer',
        screenResolution: `${width}x${height}`,
        deviceType
      };
    }

    try {
      const token = localStorage.getItem('federateIdToken') || sessionStorage.getItem('federateIdToken');
      if (!token) return null;
      
      const payload = JSON.parse(atob(token.split('.')[1]));
      return {
        sub: payload.sub,
        AMZN_LOC_DESCR: payload.AMZN_LOC_DESCR,
        DISPLAY_NAME: payload.DISPLAY_NAME,
        BUILDING_CODE: payload.BUILDING_CODE,
        MANAGER_LOGIN: payload.MANAGER_LOGIN,
        COUNTRY: payload.COUNTRY,
        COST_CENTER: payload.COST_CENTER,
        JOB_TITLE: payload.JOB_TITLE,
        screenResolution: `${width}x${height}`,
        deviceType
      };
    } catch {
      return null;
    }
  }

  async trackSessionStart() {
    if (this.sessionTracked) return;
    
    const userContext = this.getUserContext();
    if (!userContext) return;

    const event: AnalyticsEvent = {
      eventType: 'session_start',
      userContext,
      timestamp: new Date().toISOString()
    };

    this.sessionTracked = true;

    // Local development mode - just log to console
    if (isLocalDevelopment()) {
      console.log('📊 Analytics Event:', event);
      return;
    }

    try {
      const tr = new TokenRetriever(currentStage);
      const federateToken = await tr.getTokenOrRedirect();
      
      await fetch(`${baseUrl}/analytics`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': federateToken as string
        },
        body: JSON.stringify(event)
      });
    } catch (error) {
      console.error('Analytics error:', error);
    }
  }
}

export const analytics = new Analytics();
